import { render, staticRenderFns } from "./VerificationIdle.vue?vue&type=template&id=25586f49&scoped=true&"
import script from "./VerificationIdle.vue?vue&type=script&lang=js&"
export * from "./VerificationIdle.vue?vue&type=script&lang=js&"
import style0 from "./VerificationIdle.vue?vue&type=style&index=0&id=25586f49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25586f49",
  null
  
)

export default component.exports